// Filter: a puzzle is worth posing only when the right move changes the
// outcome. A +9 that became +6, or a lone king against many pieces, is not a
// puzzle: both moves leave the same side winning. The swing between the best
// line and the played move is measured as win probability and must reach
// MIN_SWING, which with the bar's mapping is one pawn in a level game
// (+0.5 to -0.5 is 0.124) and far more in a decided one (+9 to +6 is 0.036).
import { winProbability } from './win-probability.ts';

export const MIN_SWING = 0.12;

/** Both scores in centipawns from the reader's side. */
export function isOutcomeChanged(best: number, played: number): boolean {
  return winProbability(best) - winProbability(played) >= MIN_SWING;
}
